import React from 'react';
import PropTypes from 'prop-types';
import { PageTypes } from '../../../social/constants';
import useCategory from '../../../social/hooks/useCategory';
import CategoryCommunitiesList from '../../../social/components/community/CategoryCommunitiesList';
import { useNavigation } from '../../../social/providers/NavigationProvider';
import ArrowLeft from '../../../icons/ArrowLeft';
import { BackButton, Header, PageContainer, Title } from './styles';
const CategoryCommunitiesPage = ({ categoryId }) => {
    const { onChangePage } = useNavigation();
    const { category } = useCategory(categoryId);
    const title = (category === null || category === void 0 ? void 0 : category.name) || '';
    const onBack = () => onChangePage(PageTypes.Explore);
    return (React.createElement(PageContainer, null,
        React.createElement(Header, null,
            React.createElement(BackButton, { onClick: onBack },
                React.createElement(ArrowLeft, { height: 14 })),
            React.createElement(Title, null, title)),
        React.createElement(CategoryCommunitiesList, { categoryId: categoryId })));
};
CategoryCommunitiesPage.propTypes = {
    categoryId: PropTypes.string.isRequired,
};
export default CategoryCommunitiesPage;
//# sourceMappingURL=index.js.map